import { Form, Formik } from 'formik'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup'
import axiosService from '../../../utils/AxiosService';
import Input from '../../FormComponents/Input'
import { toastError, toastSuccess } from '../../FormComponents/Toasts';

export default function ResetPassword() {
  const navigate = useNavigate()
  const { token } = useParams()
  const passwordResetSchema = Yup.object().shape({
    password: Yup.string()
      .required('Required')
      .min(8, 'The password has to be at least 8 characters long.')
      .test({
        test: password => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&_])[^\s]{8,}$/.test(password),
        message: "New password should contains at least one lowercase letter, one uppercase letter, one number and one special character"
      }),
    password_confirmation: Yup.string()
      .required('Required')
      .when('password', ([password], schema) => {
        return schema.test({
          test: password_confirmation => !!password && password_confirmation === password,
          message: "Should be equal to new password"
        })
      }),
  });

  const handleSubmit = ({ password, password_confirmation }) => {
    axiosService.post(`/api/project_manager/password/forgotten_password_reset`, { token, password: { password, password_confirmation }})
    .then(({ message }) => {
      toastSuccess(message)
      navigate('/project_manager/login')
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <div className='flex h-screen w-screen bg-rb-grey relative overflow-hidden'>
      <img src="/static/background_images/login-shape-left.png" alt="bottom corner lines" className='absolute -bottom-40 -left-40 -z-5' />
      <img src="/static/background_images/login-shape-right.png" alt="top corner lines" className='absolute -top-40 -right-40 -z-5' />
      <div className="m-auto">
        <div className='flex justify-center align-center mb-5 z-5'>
          <img src="/static/reachbird_logo.png" alt="Logo" className="h-7" />
          <h1 className='pl-2 text-center align-middle text-2xl font-bold'>Reachbird</h1>
        </div>
        <div
          className='flex flex-col justify-between align-center bg-white rounded-lg p-6 relative'
          style={{ height: 500, width: 320 }}
        >
          <Formik
            initialValues={{ password: '', password_confirmation: '' }}
            validationSchema={passwordResetSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, handleBlur, handleChange, values }) => (
              <Form>
                <div className="relative">
                  <Input
                    error={touched.password && errors.password}
                    label="Password"
                    name="password"
                    noLabelPadding
                    placeholder="Password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    type="password"
                  />
                </div>
                <div className="relative">
                  <Input
                    error={touched.password_confirmation && errors.password_confirmation}
                    label="Password confirmation"
                    name="password_confirmation"
                    noLabelPadding
                    placeholder="Password confirmation"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password_confirmation}
                    type="password"
                  />
                </div>
                <div className="relative mt-5">
                  <button
                    type="submit"
                    className="submit text-left w-full text-white bg-rb-green rounded-lg w-full py-2 text-center active:shadow-outer active:shadow"
                  >
                    Confirm changes
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}